import type { User } from '../types/user';

/**
 * True when the API indicates INE is on file.
 */
export function userHasIneOnFile(user: User | null | undefined): boolean {
  return user?.ineUploaded === true;
}

/**
 * Normalizes user from API/cookies so `ineUploaded` is a strict boolean when needed.
 */
function normalizeUser(raw: User): User {
  return {
    ...raw,
    ineUploaded: raw.ineUploaded === true,
  };
}

export default normalizeUser;
